import noop from 'lodash/noop';
import { publish } from 'pubsub-js';

export const EVENT_FREE_TEXT_QUESTION = 'EVENT_FREE_TEXT_QUESTION';

/**
 * dispatchChatbotQuestion
 * ask a chatbot question. when we use rehype-react, the output is already a react element,
 * which means we already has the output of the function component, which also means it can't
 * accept params. So we can only use a event messaging channel to connect.
 * @param {string} question
 */
const dispatchChatbotQuestion = (question) => {
  publish(EVENT_FREE_TEXT_QUESTION, question);
};

export const setChatbotAskQuestionGlobal = () => {
  window.ask_question = dispatchChatbotQuestion;
  window.va = {
    ask: dispatchChatbotQuestion,
  };
};

const BOT_NAV_ON_CLICK_REGEX = /^javascript:bot_nav\((.*)\);$/;

/**
 * extractBotNavParams
 * extract params for bot nav link
 */
const extractBotNavParams = (onClickString) => {
  const matches = onClickString.match(BOT_NAV_ON_CLICK_REGEX);

  return matches[1].split(', ').map((item) => item.slice(1, -1));
};

const ASK_QUESTION_REGEX =
  /^((ask_question)|(javascript:ask_question))\((?<params>.*)\)/;

/**
 * extractAskQuestion
 * extract the question for ask_question link
 */
const extractAskQuestion = (onClickString) => {
  try {
    return onClickString
      .match(ASK_QUESTION_REGEX)
      .groups.params.split(',')[0]
      .slice(1, -1);
  } catch (e) {
    return null;
  }
};

const VA_ASK_REGEX = /^va\.ask\('(.*)'\)$/;

/**
 * extractVaAsk
 * extract the question for va.ask link
 */
const extractVaAskQuestion = (onClickString) => {
  const matches = onClickString.match(VA_ASK_REGEX);

  return matches[1];
};

/**
 * getOnClickFunc
 * map the onClick string to function
 * @todo need to handle va.ask and ask_question
 * @param {string} onClickString
 * @returns
 */
export const getOnClickFunc = (onClickString) => {
  try {
    // eslint-disable-next-line no-script-url
    if (onClickString.startsWith('javascript:bot_nav')) {
      return (event) => {
        event.preventDefault();

        const [url, target] = extractBotNavParams(onClickString);
        const openInNewTab = target === '_blank';
        const win = window.open(url, openInNewTab ? '_blank' : '_self');

        if (openInNewTab) {
          win.focus();
        }
      };
    }

    if (ASK_QUESTION_REGEX.test(onClickString)) {
      return (event) => {
        event.preventDefault();

        const question = extractAskQuestion(onClickString);

        question && dispatchChatbotQuestion(question);
      };
    }

    if (onClickString.startsWith('va.ask(')) {
      return (event) => {
        event.preventDefault();

        dispatchChatbotQuestion(extractVaAskQuestion(onClickString));
      };
    }

    return noop;
  } catch (e) {
    return noop;
  }
};
